<script>
import Layout from "@/views/layouts/main";

import appConfig from "@/app.config";
import tableSearch from "@/mixins/tableSearch";
import pagination from "@/mixins/pagination";
import ModalConfirmSubmit from "@/views/pages/estimate/ModalConfirmSubmit.vue";
import CommonTableComponent from "@/components/table.vue";
import SearchDataCustomerForEstimateModal from "@/components/InputSearchModal/SearchDataCustomerForEstimateModal.vue";
import SearchDataDischargerModal from "@/components/InputSearchModal/SearchDataDischargerModal.vue";
import SearchDataProductModal from "@/components/InputSearchModal/SearchDataProductModal.vue";
import SearchDataProjectModal from "@/components/InputSearchModal/SearchDataProjectModal.vue";
import SearchDataDischagerSiteModal from "@/components/InputSearchModal/SearchDataDischargerSiteModal.vue";
import SearchDataWasteModal from "@/components/InputSearchModal/SearchDataWasteModal.vue";
import SearchDataServiceModal from "@/components/InputSearchModal/SearchDataServiceModal.vue";
import apiEndpoints from "@/services/apiEndpoints";
import user from "@/mixins/user";

export default {
  name: "estimates.index",
  page: {
    title: "見積管理",
    meta: [{ name: "description", content: appConfig.description }]
  },
  mixins: [tableSearch, pagination, user],
  components: {
    Layout,
    CommonTableComponent,
    ModalConfirmSubmit,
    SearchDataCustomerForEstimateModal, // 見積管理用に汎用部品をカスタマイズした、名称の直接入力を不可にして customers.id で検索するためのフォーム
    SearchDataDischargerModal,
    SearchDataProductModal,
    SearchDataProjectModal,
    SearchDataDischagerSiteModal,
    SearchDataWasteModal,
    SearchDataServiceModal,
  },
  data() {
    return {
      estimates: [],
      filters: {
        customer: this.$route.query.customer || "",
        customer_name: this.$route.query.customer_name || "",
        discharger: this.$route.query.discharger || "",
        discharger_site: this.$route.query.discharger_site || "",
        case: this.$route.query.case || "",
        waste: this.$route.query.waste || "",
        service: this.$route.query.service || "",
        invoice_product_name: this.$route.query.invoice_product_name || "",
        column: this.$route.query.column || "estimates.id",
        dir: this.$route.query.dir || "DESC",
        page: Number(this.$route.query.page) || 1,
        searchToken: 0
      },
      isCheckedAll: false,
      selectedItems: [],
      constant: this.$constant,
      isSameCustomer: false,
      checkedCustomer: null,
    };
  },
  async created() {
    // 検索条件に何も設定されていない場合のみチェックを初期化したい
    let q = this.$route.query;
    if(!q.customer && !q.discharger && !q.discharger_site && !q.waste && !q.service && !q.invoice_product_name && !q.case){
      this.resetSelectedItems();
      this.resetStateCustomerName();
    }
    await this.getData();
    this.updateSelectedItemsByPage();
  },
  methods: {
    async getData() {
      this.busyGetData = true;
      this.isSameCustomer = false;
      const response = await this.$http.get(apiEndpoints.estimates, {
        ...this.filters
      });
      const { status, data } = response;
      this.busyGetData = false;
      if (status) {
        const result = data.result;
        this.estimates = this.$_.isEmpty(result.data) ? [] : result.data;
        const meta = this.$_.isEmpty(result.meta) ? [] : result.meta;
        this.setMeta(meta);
        // ここで「検索結果のすべての取引先が同じならチェック可能」としている
        if (this.filters.customer && this.estimates.length > 0) {
          this.isSameCustomer = this.allCustomersSame(this.estimates);
        }
      }
    },
    allCustomersSame(estimates) {
      const firstCustomer = estimates[0].customer_name;

      return !estimates.some(item => item.customer_name !== firstCustomer);
    },
    search() {
      this.resetToFirstPage();
      this.updateUrlFilters();
    },
    onSelectData(data) {
      this.filters = data;
    },
    onClickSubmitSelectedData() {
      if (!this.selectedItems.length) return;

      this.openModalConfirmSubmitSelectedData(this.getDataToSubmit());
    },
    getDataToSubmit() {
      let ids = [];
      const data = this.selectedItemsAllPages;
      Object.keys(data).map(function(key) {
        ids = [...ids, ...data[key]];
      });

      return ids;
    },
    openModalConfirmSubmitSelectedData(data) {
      this.$refs.modal_confirm_submit.openModal(data);
    },
    closeModalConfirmSubmitSelectedData() {
      this.$refs.modal_confirm_submit.closeModal();
    },
    onDataSubmitted() {
      this.selectedItems = [];
      this.isCheckedAll = false;
      this.closeModalConfirmSubmitSelectedData();
      this.getData();
    },
    updateSelectedItemsByPage() {
      this.selectedItems = this.selectedItemsAllPages[this.filters.page] || [];
    },
    handleCheckboxAllChange(newValue) {
      this.selectedItems = newValue ? this.estimates.map(item => item.id) : [];
    },
    resetSelectedItems() {
      this.$store.dispatch("estimate/resetSelectedItems");
    },
    resetStateCustomerName() {
      this.$store.dispatch("estimate/resetCustomerName");
    },

    clearDataSearch() {
      this.resetFilters();
      this.resetToFirstPage();
      this.updateUrlFilters();
      this.resetSelectedItems();
      this.resetStateCustomerName();
    },
    resetFilters() {
      for (const key in this.filters) {
        this.filters[key] = ""
      }
      this.filters.column = "estimates.id";
      this.filters.dir = "DESC";
    },
    onClickRow(row) {
      // これだとdisableでも入ってしまう
      // checkboxがdisabledであれば何もせずreturnしたいが…
      // 動的にrefsはつけられなさそうなのでループしてチェックするしかない

      // this.$refs.listItemId.forEach(function(obj){
      //   if(obj.value == row.id){
      //     if(obj.isDisabled){
      //       return;
      //     }
      //   }
      // });
      
      find = this.$refs.listItemId.find((obj)=>{return (obj.value == row.id && obj.isDisabled)});
      if(find) return;

      const value = row.id;
      if (this.selectedItems.includes(value)) {
        const index = this.selectedItems.indexOf(value);
        if (index > -1) {
          this.selectedItems.splice(index, 1);
        }
      } else {
        this.selectedItems.push(value);
      }
    },
    isSameNameByState(item){
      // 何もstateされていない場合はチェック許可
      if (this.$store.state.estimate.storeCustomerName == null){return true}
      return this.$store.state.estimate.storeCustomerName === item.customer_name
    },
  },
  watch: {
    "filters.page": {
      immediate: false,
      handler(newVal, oldVal) {
        this.updateFiltersWithoutSearch();
        this.updateUrlFilters();
      }
    },
    selectedItems: {
      immediate: false,
      handler(value) {
        this.$store.dispatch("estimate/updateSelectedItems", { data: value, page: this.meta.current_page });
        if (this.estimates.length) {
          // 検索結果のid値の一覧と選択済みのid値の一覧が一致するなら変数をtrueに
          // どこで使ってるかは不明
          this.isCheckedAll = this.$_.isEqual(this.$_.cloneDeep(value).sort(), this.estimates.map(item => item.id).sort());
        }
        
        if(value.length){
          // 選択しているチェックの取引先名をステートする。idは取ってないので名前で…
          // チェックできたというときはその時のどのestimatesをとっても取引先名は同じ
          if(this.$store.state.estimate.storeCustomerName == null){
            // 何もストアされていない時だけ置き換える
            this.$store.dispatch("estimate/storeCustomerName", {name: this.estimates[0].customer_name});
          }
        }else{
          // チェックが空になったときはステート削除
          this.$store.dispatch("estimate/resetCustomerName");

        }
      }
    },
  },
  computed: {
    headers() {
      return this.$constant.tableHeaders.estimates.index;
    },
    isDisableSearchService() {
      return !!this.filters.waste;
    },
    isDisableSearchWaste() {
      return !!this.filters.service;
    },
    selectedItemsAllPages() {
      return this.$store.state.estimate.selectedItemsAllPages;
    },
  }
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-lg-12">
        <div class="card mb-1">
          <div class="card-body">
            <div class="d-flex gap-4">
              <div class="button-items">
                <b-button
                  class="text-nowrap"
                  size="lg"
                  variant="success"
                  @click="onClickSubmitSelectedData"
                  v-if="canUserEdit()"
                >
                  <i class="fas fa-paper-plane"></i>
                  SQA送信
                </b-button>
            </div>
            <div class="d-flex align-items-center fw-bold font-size-16" style="color: red;">
              得意先を指定して、SQA送信する見積明細を選択する必要があります。<br>
              得意先略称で得意先を検索ボタンで絞り込んだあと、明細を選択し、SQA送信ボタンを押してください。
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card mb-1">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4">
                <SearchDataCustomerForEstimateModal
                  :dataSearch="filters"
                  @dataSelected="onSelectData"
                >
                  <template v-slot:label>
                    <label :for="'customer'" class="col-form-label text-nowrap me-2 mw-130">
                      得意先略称
                    </label>
                  </template>
                </SearchDataCustomerForEstimateModal>
              </div>
              <div
                :class="{
                  'col-md-4': true,
                  'search-input-disable': isDisableSearchWaste
                }"
              >
                <SearchDataWasteModal
                  :disabledSearch="isDisableSearchWaste"
                  :dataSearch="filters"
                  @dataSelected="onSelectData"
                >
                  <template v-slot:label>
                    <label :for="'project'" class="col-form-label text-nowrap me-2 mw-70">
                      廃棄物
                    </label>
                  </template>
                </SearchDataWasteModal>
              </div>
              <div
                :class="{
                  'col-md-4': true,
                  'search-input-disable': isDisableSearchService
                }"
              >
                <SearchDataServiceModal
                  :disabledSearch="isDisableSearchService"
                  :dataSearch="filters"
                  @dataSelected="onSelectData"
                >
                  <template v-slot:label>
                    <label :for="'project'" class="col-form-label text-nowrap me-2 mw-70">
                      サービス
                    </label>
                  </template>
                </SearchDataServiceModal>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <SearchDataProjectModal
                  :dataSearch="filters"
                  @dataSelected="onSelectData"
                >
                  <template v-slot:label>
                    <label :for="'project'" class="col-form-label text-nowrap me-2 mw-130">
                      商流
                    </label>
                  </template>
                </SearchDataProjectModal>
              </div>
              <div class="col-md-4">
                <SearchDataDischargerModal
                  :dataSearch="filters"
                  @dataSelected="onSelectData"
                >
                  <template v-slot:label>
                    <label :for="'business_person'" class="col-form-label text-nowrap me-2 mw-70">
                      事業者略称
                    </label>
                  </template>
                </SearchDataDischargerModal>
              </div>
              <div class="col-md-4">
                <SearchDataDischagerSiteModal
                  :dataSearch="filters"
                  @dataSelected="onSelectData"
                >
                  <template v-slot:label>
                    <label :for="'workplace'" class="col-form-label text-nowrap me-2 mw-70">
                      事業場略称
                    </label>
                  </template>
                </SearchDataDischagerSiteModal>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <div class="mb-2 d-xl-flex">
                  <label
                    :for="'project'"
                    class="col-form-label text-nowrap me-2 mw-130"
                  >
                    請求書表示用商品名</label
                  >
                  <div class="d-flex w-100">
                    <b-form-input
                      v-model="filters.invoice_product_name"
                      type="text"
                    ></b-form-input>
                  </div>
                </div>
              </div>
            </div>
            <b-row>
              <div class="d-flex justify-content-center align-items-center">
                <b-button size="lg" variant="primary" @click="search" class="me-2">
                  <div class="d-flex align-items-center justify-content-center">
                    <i class="fas fa-search"></i> {{ this.$lang.button.search }}
                  </div>
                </b-button>
                <b-button @click="clearDataSearch" variant="dark" size="lg">
                  <i class="fas fa-eraser"></i> {{ this.$lang.button.clear }}
                </b-button>
              </div>
            </b-row>
          </div>
          <ModalConfirmSubmit
            ref="modal_confirm_submit"
            @dataSubmitted="onDataSubmitted"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <b-overlay
            :show="busyGetData"
            rounded
            opacity="0.6"
            spinner-small
            spinner-variant="primary"
            class="d-inline-block"
          >
            <div class="card-body">
              <CommonTableComponent :height-class="`table-wrapper-500`" class="text-small">
                <thead class="table-light">
                  <tr>
                    <th class="text-center">
                      <b-form-checkbox
                        v-model="isCheckedAll"
                        @change="handleCheckboxAllChange"
                        :disabled="!isSameCustomer"
                      />
                    </th>
                    <th
                      v-for="(item, index) in headers"
                      :key="index"
                      :class="[...getHeaderClass(item), 'text-center']"
                    >
                      <span v-if="item.sortable" @click="clickSort(item.value)">
                        <span v-html="item.text"></span>
                        <i :class="getSortClass(item.value)"></i>
                      </span>
                      <span v-else v-html="item.text"> </span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in estimates" :key="index" @click="onClickRow(item)">
                    <td class="text-center">
                      <b-form-checkbox
                        :disabled="!isSameCustomer || !isSameNameByState(item)"
                        :value="item.id"
                        :checked="item.checked"
                        v-model="selectedItems"
                        ref="listItemId"
                      />
                    </td>
                    <td>
                      {{ item.id }}
                    </td>
                    <td>
                      {{ item.estimate_cd }}
                    </td>
                    <td>
                      {{ item.case_name }}
                    </td>
                    <td>
                      {{ item.waste_work_name }}
                    </td>
                    <td>
                      {{ item.customer_name }}
                    </td>
                    <td>
                      {{ item.discharger_name }}
                    </td>
                    <td>
                      {{ item.discharger_site_name }}
                    </td>
                    <td>
                      {{ item.invoice_product_name }}
                    </td>
                    <td>
                      {{ item.unit_name }}
                    </td>
                    <td class="text-end col-price">
                      <div v-if="item.unit_price">{{ item.unit_price | number}}</div>
                      <div v-if="item.unit_price_2">{{ item.unit_price_2 | number}}</div>
                      <div v-if="item.unit_price_3">{{ item.unit_price_3 | number}}</div>
                    </td>
                    <td class="text-end col-price">
                      <div v-if="item.unit_cost">{{ item.unit_cost | number}}</div>
                      <div v-if="item.unit_cost_2">{{ item.unit_cost_2 | number}}</div>
                      <div v-if="item.unit_cost_3">{{ item.unit_cost_3 | number}}</div>
                    </td>
                    <td class="col-end-date">
                      <div v-if="item.end_date_of_application">{{ item.end_date_of_application}}</div>
                      <div v-if="item.end_date_of_application_2">{{ item.end_date_of_application_2}}</div>
                      <div v-if="item.end_date_of_application_3">{{ item.end_date_of_application_3}}</div>
                    </td>
                  </tr>
                  <tr v-if="!estimates.length && !busyGetData">
                    <td colspan="14" class="text-center">
                      データなし。
                    </td>
                  </tr>
                  <!-- end /tr -->
                </tbody>
              </CommonTableComponent>
            </div>
          </b-overlay>
        </div>
        <div
          class="d-flex justify-content-between mt-3"
          v-if="meta.total && Object.keys(meta).length"
        >
          <div class="d-flex align-items-center">
            <b-pagination
              v-model="filters.page"
              :total-rows="meta.total"
              :per-page="meta.per_page"
            ></b-pagination>
          </div>
          <div class="d-flex align-items-center">
            <div class="me-2">
              {{ meta.from }} - {{ meta.to }} / {{ meta.total }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style scoped>
.search-input-disable {
  opacity: 0.5;
}
.text-small {
  font-size: 12px;
}
.col-price {
  min-width: 80px;
  white-space: pre-line !important;
}
.col-end-date {
  min-width: 111px;
  white-space: pre-line !important;
}
</style>
